import { DetailedHTMLProps, LabelHTMLAttributes } from "react";
import { mcn } from "../utils";

export type LabelProps = { 
  text?: string;
  isMandatory?: boolean; // <-- import the optional prop here
} & DetailedHTMLProps<
  LabelHTMLAttributes<HTMLLabelElement>,
  HTMLLabelElement
>;

const Label = ({ children, className, text, isMandatory, ...rest }: LabelProps) => {
  return (
    <label {...rest} className={mcn("inline-flex text-style-subtitle1", className)}>
      {text ?? children} {isMandatory && <span className="text-[#f01e2c]"> *</span>}
    </label>
  );
};

export default Label;